"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayedTransition = exports.immediateTransition = exports.fadeOut = exports.fadeIn = void 0;
const d3 = __importStar(require("d3"));
const fadeIn = selection => {
  selection.style('opacity', 1);
};
exports.fadeIn = fadeIn;
const fadeOut = selection => {
  selection.style('opacity', 0);
};
exports.fadeOut = fadeOut;
const immediateTransition = params => d3.transition().duration(params.transitionDuration);
exports.immediateTransition = immediateTransition;
const delayedTransition = params => d3.transition().delay(params.transitionDuration).duration(params.transitionDuration);
exports.delayedTransition = delayedTransition;